module.exports = __webpack_public_path__ + "public/img/fix1.cb9d7db0.jpg";